/* eslint-disable */
import { Tooltip } from '@patternfly/react-core';
import { timestampToYYYYMMDDHHMMSS } from '../../utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { useApplication } from '../../components/user/ApplicationProvider';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

export const getEntityMetaInfoTitle = (
	modalTitle: string,
	currentObject: any,
	customIconSize?: SizeProp
) => {
	const { users } = useApplication();
	const createdUser =
		users.find((x) => x.id == currentObject.creator)?.name ??
		users.find((x) => x.id == currentObject.owner)?.name;
	const updatedUser = users.find((x) => x.id == currentObject.updater)?.name ?? '-';

	if (!currentObject.id) {
		return <span className="pr-10">{modalTitle}</span>;
	}

	const tootipHtml = (
		<div className="custom-tooltip">
			<ul className="key-value-list">
				<li>
					<span className="label">Entity ID:</span>
					<span className="value">{currentObject.id}</span>
				</li>
				<li>
					<span className="label">Created Date:</span>
					<span className="value">
						{(currentObject.created_at &&
							timestampToYYYYMMDDHHMMSS(currentObject.created_at)) ??
							'-'}
					</span>
				</li>
				<li>
					<span className="label">Creating User:</span>
					<span className="value">{createdUser ?? '-'}</span>
				</li>
				<li>
					<span className="label">Last Updated Date:</span>
					<span className="value">
						{(currentObject.updated_at &&
							timestampToYYYYMMDDHHMMSS(currentObject.updated_at)) ??
							'-'}
					</span>
				</li>
				<li>
					<span className="label">Last Update User:</span>
					<span className="value">{updatedUser}</span>
				</li>
			</ul>
		</div>
	);
	return (
		<>
			<span className="pr-10">{modalTitle}</span>
			<Tooltip
				className="wider-tooltip"
				content={tootipHtml}
			>
				<FontAwesomeIcon
					size={customIconSize ?? '1x'}
					icon={faInfoCircle}
				/>
			</Tooltip>
		</>
	);
};
